import * as ReactService from "@intech/react-service";
import { DependenteEntidade } from "../entidades/DependenteEntidade";

class Dependente extends ReactService.BaseService {
  constructor() {
    super("Dependente");
  }

  Buscar = () =>
    this.CreateRequest<DependenteEntidade[]>(ReactService.RequestType.GET, `Buscar`);

}

export const DependenteService = new Dependente();
